import Dashboard from '@/components/dashboard';

export default Dashboard;
